import React from "react";
import "./Footer.css";

const translations = {
  tr: {
    slogan: "Sınırları Aşan Hukuki Güven.",
    description: "Uluslararası süreçlerde yanınızda, çözüm odaklı ve stratejik danışmanlık.",
    contactInfo: "İletişim Bilgileri",
    address: "Adres",
    phone: "Telefon",
    email: "E-posta",
    followUs: "Bizi Takip Edin",
    rights: "Tüm hakları saklıdır."
  },
  en: {
    slogan: "Legal Confidence Beyond Borders.",
    description: "Strategic and solution-driven international legal consultancy at your side.",
    contactInfo: "Contact Information",
    address: "Address",
    phone: "Phone",
    email: "Email",
    followUs: "Follow Us",
    rights: "All rights reserved."
  },
  fr: {
    slogan: "La Confiance Juridique Sans Frontières.",
    description: "Un accompagnement stratégique et orienté solutions pour vos démarches internationales.",
    contactInfo: "Coordonnées",
    address: "Adresse",
    phone: "Téléphone",
    email: "Email",
    followUs: "Suivez-Nous",
    rights: "Tous droits réservés."
  },
  ku: {
    slogan: "Hevkarê We yê Bawermend di Şêwirmendiya Hiqûqî de",
    description: "Kompanek profesyonel ku di şêwirmendiya hiqûqî ya navneteweyî de pispor e û çareseriyên berfireh ji mişteriyên xwe re peyda dike.",
    contactInfo: "Agahiyên Têkiliyê",
    address: "Navnîşan",
    phone: "Têlefon",
    email: "E-name",
    followUs: "Me Bişopînin",
    rights: "Hemû maf parastî ne."
  }
};

export const Footer = ({ lang, isDarkMode }) => {
  const currentLang = lang?.toLowerCase() || 'tr';
  const t = translations[currentLang] || translations.tr;

  return (
    <footer className={`main-footer ${isDarkMode ? "footer-dark" : ""}`}>
      <div className="container">
        <div className="row footer-content-row">

          {/* Sol Sütun: Logo ve Slogan */}
          <div className="col-lg-5 col-md-12 mb-5 footer-brand-column">
            <img
              src={isDarkMode ? "/img/logo-dark.png" : "/img/logo-light.png"}
              alt="Akay Conseil Logo"
              className="footer-logo-main"
            />
            <div className="footer-title-line" />
            <p className="footer-slogan">{t.slogan}</p>
            <p className="footer-desc-text">{t.description}</p>
          </div>

          {/* Sağ Sütun: İletişim Bilgileri */}
          <div className="col-lg-4 col-md-12 mb-5 ms-auto footer-contact-column">
            <h4 className="footer-heading">{t.contactInfo}</h4>

            <div className="footer-contact-item">
              <div className="footer-icon-box"><i className="fa fa-map-marker"></i></div>
              <div className="footer-text-box">
                <p className="footer-item-label">{t.address}</p>
                <p className="footer-item-value">Kızıltepe, Mardin, Turkey</p>
              </div>
            </div>

            <div className="footer-contact-item">
              <div className="footer-icon-box"><i className="fa fa-envelope"></i></div>
              <div className="footer-text-box">
                <p className="footer-item-label">{t.email}</p>
                <a href="mailto:info@xconsulting.com" className="footer-link">info@xconsulting.com</a>
              </div>
            </div>

            <div className="footer-contact-item mb-4">
              <div className="footer-icon-box"><i className="fa fa-phone"></i></div>
              <div className="footer-text-box">
                <p className="footer-item-label">{t.phone}</p>
                <a href="tel:+905054296747" className="footer-link">+90 505 429 6747</a>
              </div>
            </div>

            <div className="footer-social-section">
              <p className="footer-item-label mb-3">{t.followUs}</p>
              <div className="footer-social-icons">
                <a href="#" className="social-icon fb"><i className="fa fa-facebook"></i></a>
                <a href="#" className="social-icon ig"><i className="fa fa-instagram"></i></a>
                <a href="#" className="social-icon x">𝕏</a>
                <a href="#" className="social-icon in"><i className="fa fa-linkedin"></i></a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom-bar">
          <p>© {new Date().getFullYear()} <span className="footer-brand-name">Akay Conseil</span>. {t.rights}</p>
        </div>
      </div>
    </footer>
  );
};